import { render, staticRenderFns } from "./carCreateFeeList.vue?vue&type=template&id=51e1bd94&scoped=true"
import script from "./carCreateFeeList.vue?vue&type=script&lang=js"
export * from "./carCreateFeeList.vue?vue&type=script&lang=js"
import style0 from "./carCreateFeeList.vue?vue&type=style&index=0&id=51e1bd94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e1bd94",
  null
  
)

export default component.exports